module.exports = __webpack_public_path__ + "img/category_37.149f7f81.png";